import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---------- Analyze ----------
export const analyzeMedications = async (medications, notes) => {
  const { data } = await http.post(`/analyze`, { medications, notes: notes || null });
  return data;
};
export const fetchHistory = async (limit = 5) => {
  const { data } = await http.get(`/history`, { params: { limit } });
  return data;
};

// ---------- Auth ----------
export const exchangeSession = async (session_id) => {
  const { data } = await http.post(`/auth/google-session`, { session_id });
  return data.user;
};
export const fetchMe = async () => {
  const { data } = await http.get(`/auth/me`);
  return data;
};
export const logout = async () => {
  await http.post(`/auth/logout`);
};

// ---------- Reminders ----------
export const getPrefs = async () => (await http.get(`/reminders/preferences`)).data;
export const setPrefs = async (p) => (await http.put(`/reminders/preferences`, p)).data;
export const sendTestReminder = async () => (await http.post(`/reminders/send-test`)).data;

// ---------- Billing ----------
export const getPackages = async () => (await http.get(`/billing/packages`)).data;
export const createCheckout = async (package_id) => {
  const origin_url = window.location.origin;
  const { data } = await http.post(`/billing/checkout`, { package_id, origin_url });
  return data;
};
export const billingStatus = async (session_id) => {
  const { data } = await http.get(`/billing/status/${session_id}`);
  return data;
};
